import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import AddNewVisitor from './AddNewVisitor';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';
import { Spinner } from 'react-bootstrap';
import {
  IRegisteredStaff,
  useDeleteRegisteredStaff,
  useGetRegisteredStaff,
} from './apiEndpoints/registeredVisitorEndpoint';
import CommonModal from '../../../../Components/Common/CommonModal';
import { imgUrl } from '../../../../Helpers/Constant';
import EditStaff from './EditStaff';
import PopOver from '../../../../Components/PopOver/PopOver';
import CommProfileHeader from '../CommProfileHeader';
import DownloadStaffIdCard from './DownloadStaffIdCard';

const RegisteredStaff = () => {
  const {
    state: { exhibitorUser },
  } = useExhibitorAuthContext();
  const [toggle, setToggle] = useState(false);
  const { data, isLoading } = useGetRegisteredStaff();

  const { mutate } = useDeleteRegisteredStaff();
  const [dataStaff, setDataStaff] = useState<{
    modalShow: boolean;
    data: IRegisteredStaff | undefined;
  }>({
    modalShow: true,
    data: undefined,
  });
  const handleAddVisitor = async () => {
    setToggle(!toggle);
    setDataStaff({ data: undefined, modalShow: true });
  };
  return (
    <>
      <CommProfileHeader
        addHeadingTitle='Add New Registered Staff'
        listHeadingTitle='Registered Staff List'
        createBtnText='Add Staff'
        toggle={toggle}
        setToggle={setToggle}
      />

      {toggle ? (
        <AddNewVisitor onAddVisitor={handleAddVisitor} />
      ) : (
        <div className='profile-right-side px-3 py-3'>
          <div className='profile-right-info pt-3 ps-2'>
            <Table striped bordered hover responsive>
              <thead>
                <tr className='text-center'>
                  <th>SL.</th>
                  <th>ID No.</th>
                  {/* <th className='text-success'>Download ID Card</th> */}
                  <th>Name</th>
                  <th>Designation</th>
                  <th>E-mail</th>
                  <th>Mobile</th>
                  <th>Photo</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr className='text-center'>
                    <td colSpan={5}>
                      <Spinner variant='primary' />
                    </td>
                  </tr>
                ) : (
                  <>
                    {data?.data?.length ? (
                      <>
                        {data?.data?.map((sVisitor, index) => {
                          return (
                            <tr className='text-center' key={sVisitor.id}>
                              <td>{index + 1}</td>
                              <td>{sVisitor.id_no} </td>
                              {/* <td>
                                <DownloadStaffIdCard
                                  companyName={
                                    exhibitorUser?.user_fair_member_company_name as string
                                  }
                                  staffName={sVisitor?.name}
                                  designation={sVisitor?.designation}
                                  phone={sVisitor?.phone}
                                  email={sVisitor?.email}
                                  staffId={sVisitor?.id_no}
                                />
                              </td> */}
                              <td>{sVisitor.name} </td>
                              <td>{sVisitor.designation}</td>
                              <td>{sVisitor.email}</td>
                              <td>{sVisitor.phone}</td>
                              <td>
                                {' '}
                                <span>
                                  <CommonModal
                                    showView
                                    modalTitle='Image Preview'
                                    modalOff
                                  >
                                    <img
                                      src={`${imgUrl}/${sVisitor.photo}`}
                                      alt={sVisitor.photo}
                                      width={'100%'}
                                      height={400}
                                    />
                                  </CommonModal>
                                </span>
                              </td>
                              <td className='d-flex gap-1'>
                                <span
                                  onClick={() =>
                                    setDataStaff({
                                      data: sVisitor,
                                      modalShow: false,
                                    })
                                  }
                                >
                                  <CommonModal
                                    size='lg'
                                    showEdit
                                    modalTitle='Update Staff Information'
                                    modalOff={
                                      dataStaff?.data?.id == sVisitor?.id
                                        ? false
                                        : true
                                    }
                                  >
                                    <EditStaff
                                      dataStaff={dataStaff?.data}
                                      handleModalOff={() => {
                                        setDataStaff({
                                          data: undefined,
                                          modalShow: false,
                                        });
                                      }}
                                    />
                                  </CommonModal>
                                </span>

                                <span>
                                  <PopOver
                                    confirm={() => {
                                      mutate(sVisitor?.id);
                                    }}
                                    size={23}
                                  />
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <tr className='text-center'>
                        <td colSpan={6} className='fw-bold'>
                          No data found
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  );
};

export default RegisteredStaff;
